import { useEffect } from "react";
import { FormActions } from "../../components/common/FormActions";
import FormFields from "../../components/common/FormFields";
import { VILLAGE } from "../../utils/constants";
import {
  createColumn,
  createEditAction,
  getForm,
  getRegister,
} from "../../utils/helpers";
import { URL_VILLAGES } from "../../utils/urls";
import useGet from "../common/useGet";
import { API_PARISHES } from "../../utils/apis";

export const useVillages = () => {
  const tableColumns = () => [
    createColumn("name", true, "Village"),
    createColumn("parish_name", true, "Parish"),
    createColumn("actions", false, "Actions"),
  ];
  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        actions: (
          <FormActions actions={[createEditAction(URL_VILLAGES, item?.id)]} />
        ),
      };
    }),
  ];

  const formRoute = getForm(URL_VILLAGES);

  return { tableData, tableColumns, formRoute };
};

export const useVillagesForm = () => {
  const { loadData, loading, data: parishData } = useGet();
  useEffect(() => loadData({ api: API_PARISHES }), []);
  const fields: any = [
    {
      field_name: "parent",
      type: "select",
      label: "parish",
      props: { required: true },
      options_data: parishData?.results,
      loading,
    },
    {
      field_name: "name",
      label: "Village name",
      type: "text",
      props: { required: true },
    },
  ];
  const sections: any = [
    {
      title: "Village details",
      fields,
    },
  ];

  const redirect = getRegister(URL_VILLAGES);

  const defaultValues = { location_type: VILLAGE };

  return { fields, sections, redirect, defaultValues };
};

export const VillagesForm = ({
  form,
  error,
  updateFormValue,
  onChange,
}: any) => {
  const { fields } = useVillagesForm();
  return (
    <FormFields
      fields={fields}
      error={error}
      form={form}
      updateFormValue={updateFormValue}
      onChange={onChange}
    />
  );
};
